import { render } from "./Decks.vue?vue&type=template&id=467e6b11&scoped=true"
import script from "./Decks.vue?vue&type=script&lang=js"
export * from "./Decks.vue?vue&type=script&lang=js"

import "./Decks.vue?vue&type=style&index=0&id=467e6b11&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467e6b11"]])

export default __exports__